<template>
  <div class="loginPage-container">
    <div class="bg-container"></div>

    <div class="card-container">
      <div class="title-container">
        <div class="title">知守科技</div>
        <div class="title">智慧鞋机管控平台</div>
      </div>
      <div class="info-container">
        <div class="title">格局</div>
        <div class="title">情怀</div>
        <div class="title">决心</div>
        <div class="title">结果</div>
      </div>

      <div class="inputList-container">
        <div class="login-box">
          <h2>登录</h2>
          <form>
            <div class="user-box">
              <input
                type="text"
                name=""
                required=""
                v-model="username"
                @keydown.enter="submitForm()"
              >
              <label>账号</label>
            </div>
            <div class="user-box">
              <input
                type="password"
                name=""
                required=""
                v-model="password"
                @keydown.enter="submitForm()"
              >
              <label>密码</label>
            </div>
            <a
              href="#"
              @click="submitForm()"
            >
              <span></span>
              <span></span>
              <span></span>
              <span></span>
              进入
            </a>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Login } from '../api/request.js'
import { ElMessage } from 'element-plus'

export default {
  name: 'LoginPage',
  data () {
    return {
      username: '',
      password: ''
    }
  },
  methods: {
    submitForm () {
      Login.getLogin({ loginName: this.username, password: this.password }).then(
        res => {
          // console.log(res);
          if (res.token === undefined) {
            ElMessage({
              grouping: true,
              message: '账号或密码错误',
              type: 'error',
            })
          } else {
            window.localStorage.setItem('SEBackstage', res.token)
            this.$router.push('/')
          }
        }
      );
    }
  }
}
</script>

<style scoped>
.loginPage-container {
  width: 100%;
  height: 100%;
  display: flex;
}

.bg-container {
  width: 80%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background-image: url('@/assets/loginBG3.gif');
  background-repeat: no-repeat;
  background-size: cover;
}

.card-container {
  width: 20%;
  height: 100%;
  background-color: rgb(230, 230, 230);
}

.title-container {
  height: 25%;
  /* background-color: red; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.title {
  width: 100%;
  text-align: end;
  color: #000;
  font-size: 36px;
  letter-spacing: 3px;
  margin-bottom: 25px;
  font-family: "ALiMM";
}

.info-container {
  height: 75%;
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
}

@font-face {
  font-family: ALiMM;
  /* 定义字体名称 */
  src: url('../assets/AlimamaFangYuanTiVF-Thin.ttf');
  /* 指定字体文件的路径 */
}
</style>

<style scoped>
/* 登录栏样式 */
.login-box {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 400px;
  padding: 40px;
  transform: translate(-50%, -50%);
  background: rgba(0, 0, 0, .5);
  box-sizing: border-box;
  box-shadow: 0 15px 25px rgba(0, 0, 0, .6);
  border-radius: 10px;
}

.login-box h2 {
  margin: 0 0 30px;
  padding: 0;
  color: #fff;
  text-align: center;
}

.login-box .user-box {
  position: relative;
}

.login-box .user-box input {
  width: 100%;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  margin-bottom: 30px;
  border: none;
  border-bottom: 1px solid #fff;
  outline: none;
  background: transparent;
}

.login-box .user-box label {
  position: absolute;
  top: 0;
  left: 0;
  padding: 10px 0;
  font-size: 16px;
  color: #fff;
  pointer-events: none;
  transition: .5s;
}

.login-box .user-box input:focus~label,
.login-box .user-box input:valid~label {
  top: -20px;
  left: 0;
  color: #03e9f4;
  font-size: 12px;
}

.login-box form a {
  position: relative;
  display: inline-block;
  padding: 10px 20px;
  color: #03e9f4;
  font-size: 16px;
  text-decoration: none;
  text-transform: uppercase;
  overflow: hidden;
  transition: .5s;
  margin-top: 40px;
  letter-spacing: 4px
}

.login-box a:hover {
  background: #03e9f4;
  color: #fff;
  border-radius: 5px;
  box-shadow: 0 0 5px #03e9f4,
    0 0 25px #03e9f4,
    0 0 50px #03e9f4,
    0 0 100px #03e9f4;
}

.login-box a span {
  position: absolute;
  display: block;
}

.login-box a span:nth-child(1) {
  top: 0;
  left: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(90deg, transparent, #03e9f4);
  animation: btn-anim1 1s linear infinite;
}

@keyframes btn-anim1 {
  0% {
    left: -100%;
  }

  50%,
  100% {
    left: 100%;
  }
}

.login-box a span:nth-child(2) {
  top: -100%;
  right: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(180deg, transparent, #03e9f4);
  animation: btn-anim2 1s linear infinite;
  animation-delay: .25s
}

@keyframes btn-anim2 {
  0% {
    top: -100%;
  }

  50%,
  100% {
    top: 100%;
  }
}

.login-box a span:nth-child(3) {
  bottom: 0;
  right: -100%;
  width: 100%;
  height: 2px;
  background: linear-gradient(270deg, transparent, #03e9f4);
  animation: btn-anim3 1s linear infinite;
  animation-delay: .5s
}

@keyframes btn-anim3 {
  0% {
    right: -100%;
  }

  50%,
  100% {
    right: 100%;
  }
}

.login-box a span:nth-child(4) {
  bottom: -100%;
  left: 0;
  width: 2px;
  height: 100%;
  background: linear-gradient(360deg, transparent, #03e9f4);
  animation: btn-anim4 1s linear infinite;
  animation-delay: .75s
}

@keyframes btn-anim4 {
  0% {
    bottom: -100%;
  }

  50%,
  100% {
    bottom: 100%;
  }
}
</style>
